/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Select_Event_Groups_LabelInputs */

const en_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select event groups to share`)
};

const fr_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner les groupes d’événements à partager`)
};

const de_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Ereignisgruppen aus, die Sie teilen möchten.`)
};

const it_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona i gruppi di eventi da condividere`)
};

const ru_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы мероприятий для обмена информацией.`)
};

const es_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione grupos de eventos para compartir`)
};

const zh_cn2_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要分享的活动组`)
};

const ja_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有するイベントグループを選択`)
};

const hi_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साझा करने के लिए इवेंट समूह चुनें`)
};

const pt_pt2_team_share_select_event_groups_label = /** @type {(inputs: Team_Share_Select_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os grupos de eventos para compartilhar`)
};

/**
* | output |
* | --- |
* | "Select event groups to share" |
*
* @param {Team_Share_Select_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_select_event_groups_label = /** @type {((inputs?: Team_Share_Select_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Select_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_select_event_groups_label(inputs)
	if (locale === "de") return de_team_share_select_event_groups_label(inputs)
	if (locale === "it") return it_team_share_select_event_groups_label(inputs)
	if (locale === "ru") return ru_team_share_select_event_groups_label(inputs)
	if (locale === "es") return es_team_share_select_event_groups_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_select_event_groups_label(inputs)
	if (locale === "ja") return ja_team_share_select_event_groups_label(inputs)
	if (locale === "hi") return hi_team_share_select_event_groups_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_select_event_groups_label(inputs)
	return en_team_share_select_event_groups_label(inputs)
});